<template>
  <div class="downloadBox" v-show="isShow" :class="isDel ? 'delete-dialog' : 'add-dialog'">
    <div class="title">
      <span class="title-text">
        {{ downloadBoxTit }}
      </span>
      <i class="close-btn" @click="closePopup"></i>
    </div>
    <div class="main" v-show="!isDel">
      <div class="source">
        <textarea class="txt" v-model="topText" placeholder="原文"></textarea>
      </div>
      <div class="target">
        <textarea class="txt" v-model="botText" placeholder="译文"></textarea>
      </div>
    </div>
    <div v-show="!!isDel" class="mainText">{{ downloadBoxText }}</div>
    <div class="but">
      <el-button class="themeCallBut" @click="popupCancel">取消</el-button>
      <el-button type="primary" class="themeGoBut" ref="delEnsureBtn" @click="popupConfirm">
        确定
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'operation',
  props: ['isShow', 'checkTxt', 'isDel', 'downloadBoxTit', 'downloadBoxText', 'deleteType'],
  data() {
    return {
      botText: '',
      topText: '',
    }
  },
  watch: {
    isShow: {
      handler() {
        this.selfShow = this.isShow
        if (this.isShow) {
          // this.$refs.delEnsureBtn.focus()
          document.addEventListener('keyup', this.keyUp)
        } else {
          this.topText = ''
          this.botText = ''
          document.removeEventListener('keyup', this.keyUp)
        }
      },
      immediate: false
    },
  },
  methods: {
    closePopup() {
      this.$emit('closePopup')
    },
    popupConfirm() {
      let params = {
        botText: this.botText,
        topText: this.topText,
      }
      this.$emit('popupConfirm', params)
    },
    keyUp() {
      this.$emit('keyUp')
    },
    popupCancel() {
      this.topText = ''
      this.botText = ''
      let params = {
        botText: this.botText,
        topText: this.topText,
      }
      this.$emit('popupCancel', params)
    },
  },
}
</script>

<style scoped lang="scss">
.downloadBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;

  .but {
    display: flex;
    justify-content: center;
  }

  .themeCallBut,
  .themeGoBut {
    padding: 0;
    width: 76px;
    height: 30px;
    border-radius: 4px;
    color: #0078fc;
    cursor: pointer;
  }

  .themeGoBut {
    margin-left: 20px;
    color: #ffffff;
  }
  .themeCallBut {
    border-color: #0078fc;
  }

  .title {
    padding: 25px 30px 0 30px;
    display: flex;
    justify-content: space-between;

    .title-text {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
    }

    .title-text::before {
      content: "";
      display: inline-block;
      width: 3px;
      height: 16px;
      vertical-align: middle;
      background: linear-gradient(0deg, #99c1ff, #3684ff);
      border-radius: 1px;
    }

    .close-btn {
      display: block;
      width: 15px;
      height: 15px;
      cursor: pointer;
      background: url("~@/assets/imgs/alignment-icons/button-cancel.png")
        no-repeat center;
    }
  }

  .main {
    padding: 30px 52px;

    .source,
    .target {
      .txt {
        width: 396px;
        height: 104px;
        background: #fafafd;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        resize: none;
        outline: none;
        padding: 10px;
      }
    }

    .target {
      margin-top: 20px;
    }
  }
}

.add-dialog {
  width: 500px;
  height: 445px;
  background: #ffffff;
  border-radius: 4px;
}

.delete-dialog {
  width: 360px;
  height: 193px;
  background: #ffffff;
  border-radius: 4px;

  .mainText {
    text-align: center;
    padding: 20px 0;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
}
</style>
